<template>
    <modal id="field-audit-status-modal">
        <template slot="body">
            <p>Select the status of the Field Audit.</p>

            <field-select v-model="form.status" placeholder="Final Status">
                <option value="pass">Pass</option>
                <option value="fail">Fail</option>
            </field-select>
            <field-text v-model="form.comments" :maxlength="2000"  :display-remaining-characters="true" placeholder="Comments"></field-text>

            <div v-if="form.status == 'fail'">
                <field-select v-model="form.trigger_action" emptyOption="No Action" placeholder="Trigger Action">
                    <option value="desk-audit">Trigger a Desk Audit</option>
                    <option value="field-audit">Trigger a Field Audit</option>
                    <option value="field-inspection" disabled>Trigger a Field Inspection (Not Ready)</option>
                </field-select>
            </div>

        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal('field-audit-status-modal')">
                Cancel
            </button>
            <button class="btn btn-success" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Save</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Processing...</span>
            </button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                audit: this.value,
                form: new Form({
                    trigger_action: '',
                    status: this.value.status,
                    completed_at: null,
                    comments: '',
                }).dontClear()
            }
        },

        methods: {
            save: _.debounce(function () {
                this.form.patch(`/field-audits/${this.audit.number}`).then(response => {
                    this.closeModal('field-audit-status-modal');
                    this.$emit('input', response)
                    this.refreshPage();
                });
            }, 300)
        },

        watch: {
            value(audit) {
                this.audit = audit;
            },

            'form.status'(){
                if(this.form.status != '' && this.form.status != null){
                    this.form.completed_at = moment.utc().toISOString()
                }else{
                    this.form.completed_at = null
                }
            }
        },
    }
</script>
